module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "schoolManage"
  }, [_c('div', {
    staticClass: "breadcrumb",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("\n    校区管理\n    "), _c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getallschool
    }
  }, [_vm._v("新增校区")])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新增校区",
      "modal-append-to-body": false
    },
    model: {
      value: (_vm.dialogFormVisible),
      callback: function($$v) {
        _vm.dialogFormVisible = $$v
      },
      expression: "dialogFormVisible"
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "id": "addForm",
      "label-position": "left"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "注意事项:",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("\n          1,没有匹配的学校请选择其它，请勿留空，没有选择选项之前请勿点击确定按钮\n        ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("2,选择其它后请填写学校名称后再提交")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "高校名称",
      "label-width": _vm.formLabelWidth,
      "modal-append-to-body": false
    }
  }), _vm._v(" "), _c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择学校"
    },
    on: {
      "change": _vm.isaddnewschool
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  }, _vm._l((_vm.options1), function(item) {
    return _c('el-option', {
      key: item.rootUnid + item.name + item.firstLetter,
      attrs: {
        "label": item.name,
        "value": item.rootUnid + ',' + item.firstLetter + ',' + item.name
      }
    })
  }), 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputnewschoolvisble),
      expression: "inputnewschoolvisble"
    }],
    attrs: {
      "label": "学校类型",
      "label-width": "80px"
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.changeSchoolType
    },
    model: {
      value: (_vm.form.schoolType),
      callback: function($$v) {
        _vm.$set(_vm.form, "schoolType", $$v)
      },
      expression: "form.schoolType"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("大学")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 4
    }
  }, [_vm._v("高中")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputnewschoolvisble),
      expression: "inputnewschoolvisble"
    }],
    attrs: {
      "label": "高校名称",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入高校名称"
    },
    model: {
      value: (_vm.inputnewschool),
      callback: function($$v) {
        _vm.inputnewschool = $$v
      },
      expression: "inputnewschool"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "校区名称",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入校区名称",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.namecampus),
      callback: function($$v) {
        _vm.$set(_vm.form, "namecampus", $$v)
      },
      expression: "form.namecampus"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "省份",
      "label-width": _vm.formLabelWidth,
      "required": ""
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择省份",
      "clearable": "",
      "filterable": ""
    },
    on: {
      "change": function($event) {
        _vm.form.city = ''
      }
    },
    model: {
      value: (_vm.form.province),
      callback: function($$v) {
        _vm.$set(_vm.form, "province", $$v)
      },
      expression: "form.province"
    }
  }, _vm._l((_vm.provinceList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "市",
      "label-width": _vm.formLabelWidth,
      "required": ""
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择市",
      "clearable": "",
      "filterable": "",
      "disabled": !_vm.form.province
    },
    model: {
      value: (_vm.form.city),
      callback: function($$v) {
        _vm.$set(_vm.form, "city", $$v)
      },
      expression: "form.city"
    }
  }, _vm._l((_vm.cityOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "首字母",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入首字母",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.firstletter),
      callback: function($$v) {
        _vm.$set(_vm.form, "firstletter", $$v)
      },
      expression: "form.firstletter"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开放注册",
      "label-width": "80px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.form.radio),
      callback: function($$v) {
        _vm.$set(_vm.form, "radio", $$v)
      },
      expression: "form.radio"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "2"
    },
    model: {
      value: (_vm.form.radio),
      callback: function($$v) {
        _vm.$set(_vm.form, "radio", $$v)
      },
      expression: "form.radio"
    }
  }, [_vm._v("否")])], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "校区切换权限",
      "label-width": "140px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "8px"
    }
  }, [_vm._v("允许切入")]), _vm._v(" "), _c('el-switch', {
    attrs: {
      "disabled": _vm.isDisabled,
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.form.openChangeCampusZone),
      callback: function($$v) {
        _vm.$set(_vm.form, "openChangeCampusZone", $$v)
      },
      expression: "form.openChangeCampusZone"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "8px"
    }
  }, [_vm._v("允许切出")]), _vm._v(" "), _c('el-switch', {
    attrs: {
      "disabled": _vm.isDisabled,
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.form.editChangeCampusZone),
      callback: function($$v) {
        _vm.$set(_vm.form, "editChangeCampusZone", $$v)
      },
      expression: "form.editChangeCampusZone"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "校区类型",
      "label-width": "80px"
    }
  }, [_c('el-row', [_c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.schoolType == 1),
      expression: "form.schoolType == 1"
    }],
    attrs: {
      "span": 2
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    on: {
      "input": _vm.changeCampusType
    },
    model: {
      value: (_vm.form.campusType),
      callback: function($$v) {
        _vm.$set(_vm.form, "campusType", $$v)
      },
      expression: "form.campusType"
    }
  }, [_vm._v("专科")])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.schoolType == 1),
      expression: "form.schoolType == 1"
    }],
    attrs: {
      "span": 2
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "2"
    },
    on: {
      "input": _vm.changeCampusType
    },
    model: {
      value: (_vm.form.campusType),
      callback: function($$v) {
        _vm.$set(_vm.form, "campusType", $$v)
      },
      expression: "form.campusType"
    }
  }, [_vm._v("本科")])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.schoolType == 4),
      expression: "form.schoolType == 4"
    }],
    attrs: {
      "span": 2
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "3"
    },
    on: {
      "input": _vm.changeCampusType
    },
    model: {
      value: (_vm.form.campusType),
      callback: function($$v) {
        _vm.$set(_vm.form, "campusType", $$v)
      },
      expression: "form.campusType"
    }
  }, [_vm._v("高中")])], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.schoolType == 1),
      expression: "form.schoolType == 1"
    }],
    attrs: {
      "label": "是否开启体测总分",
      "label-width": "140px"
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": "",
      "disabled": _vm.isDisabled
    },
    model: {
      value: (_vm.form.openTotalScore),
      callback: function($$v) {
        _vm.$set(_vm.form, "openTotalScore", $$v)
      },
      expression: "form.openTotalScore"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.openTotalScore),
      expression: "form.openTotalScore"
    }],
    attrs: {
      "label": "体测总分:",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('div', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("大一")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.physicalConfig[0].molecule),
      callback: function($$v) {
        _vm.$set(_vm.form.physicalConfig[0], "molecule", $$v)
      },
      expression: "form.physicalConfig[0].molecule"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('div', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("/")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.physicalConfig[0].denominator),
      callback: function($$v) {
        _vm.$set(_vm.form.physicalConfig[0], "denominator", $$v)
      },
      expression: "form.physicalConfig[0].denominator"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1,
      "offset": 1
    }
  }, [_c('div', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("大二")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.physicalConfig[1].molecule),
      callback: function($$v) {
        _vm.$set(_vm.form.physicalConfig[1], "molecule", $$v)
      },
      expression: "form.physicalConfig[1].molecule"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('div', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("/")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.physicalConfig[1].denominator),
      callback: function($$v) {
        _vm.$set(_vm.form.physicalConfig[1], "denominator", $$v)
      },
      expression: "form.physicalConfig[1].denominator"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1,
      "offset": 1
    }
  }, [_c('div', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("大三")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.physicalConfig[2].molecule),
      callback: function($$v) {
        _vm.$set(_vm.form.physicalConfig[2], "molecule", $$v)
      },
      expression: "form.physicalConfig[2].molecule"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('div', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("/")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.physicalConfig[2].denominator),
      callback: function($$v) {
        _vm.$set(_vm.form.physicalConfig[2], "denominator", $$v)
      },
      expression: "form.physicalConfig[2].denominator"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.campusType === '2'),
      expression: "form.campusType === '2'"
    }],
    attrs: {
      "span": 1,
      "offset": 1
    }
  }, [_c('div', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("大四")])]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.campusType === '2'),
      expression: "form.campusType === '2'"
    }],
    attrs: {
      "span": 1
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.physicalConfig[3].molecule),
      callback: function($$v) {
        _vm.$set(_vm.form.physicalConfig[3], "molecule", $$v)
      },
      expression: "form.physicalConfig[3].molecule"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.campusType === '2'),
      expression: "form.campusType === '2'"
    }],
    attrs: {
      "span": 1
    }
  }, [_c('div', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("/")])]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.campusType === '2'),
      expression: "form.campusType === '2'"
    }],
    attrs: {
      "span": 1
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.physicalConfig[3].denominator),
      callback: function($$v) {
        _vm.$set(_vm.form.physicalConfig[3], "denominator", $$v)
      },
      expression: "form.physicalConfig[3].denominator"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "学校任务跑用户",
      "label-width": _vm.formLabelWidth,
      "required": ""
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.form.schoolTaskRunGrades),
      callback: function($$v) {
        _vm.$set(_vm.form, "schoolTaskRunGrades", $$v)
      },
      expression: "form.schoolTaskRunGrades"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("大一")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("大二")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": 3
    }
  }, [_vm._v("大三")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": 4
    }
  }, [_vm._v("大四")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": 5
    }
  }, [_vm._v("其他")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "运动世界APP固定展示“自由跑”",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.form.showFreeRunEnableSwitch),
      callback: function($$v) {
        _vm.$set(_vm.form, "showFreeRunEnableSwitch", $$v)
      },
      expression: "form.showFreeRunEnableSwitch"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addcampus
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "500px",
      "margin-left": "20px"
    },
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请输入高校或校区名称"
    },
    on: {
      "change": _vm.neirong
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.unid,
      attrs: {
        "value": item.unid,
        "label": item.name
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "15px",
      "clear": "both",
      "overflow": "hidden",
      "width": "100%"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "com-list"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "label": "序号",
      "width": "80",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "zoneName",
      "label": "校区名称",
      "width": "280",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "省份",
      "width": "120",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_vm._v(_vm._s(_vm.getProvinceName(row.province)))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "市",
      "width": "120",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_vm._v(_vm._s(_vm.getCityName(row.province, row.city)))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "pointsNum",
      "label": "点位数量",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "campusType",
      "label": "学校类型",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "学校任务跑用户",
      "min-width": "220",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_vm._v(_vm._s(_vm.formatSchoolTaskRunGrades(row)))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "自由跑固定展示",
      "width": "140",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_vm._v(_vm._s(row && row.showFreeRunEnableSwitch ? "开启" : "关闭"))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "openRegistration",
      "label": "是否开放注册",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "openTotalScore",
      "label": "是否开启体测总分",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "是否开放场馆系统",
      "width": "180",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "校区切换权限",
      "align": "center"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('span', [_vm._v("\n          " + _vm._s(_vm.row.openChangeCampusZone ? "允许切入 " : "") + _vm._s(_vm.row.editChangeCampusZone ? "允许切出" : "") + "\n          " + _vm._s(!_vm.row.openChangeCampusZone && !_vm.row.editChangeCampusZone ? "不允许切换" : "") + "\n        ")])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "200",
      "align": "center"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('span', [_c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.editschool(_vm.row)
              }
            }
          }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.deleteSchool(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("删除")])], 1)
        
      },
      staticRenderFns: []
    }
  })], 1)], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 20,
      "page-count": _vm.pageCount
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑校区",
      "modal-append-to-body": false
    },
    model: {
      value: (_vm.dialogFormVisibleedit),
      callback: function($$v) {
        _vm.dialogFormVisibleedit = $$v
      },
      expression: "dialogFormVisibleedit"
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.formedit,
      "label-position": "left"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "注意事项",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('br'), _vm._v(" "), _c('p', [_vm._v("1,若修改的是学校名称，请确保对该校校区逐一进行此操作")]), _vm._v(" "), _c('p', [_vm._v("2,开放注册的调整对该校所有校区生效")]), _vm._v(" "), _c('p', [_vm._v("3,新增时，若学校名和首字母为空，则不能新增。新增时默认关闭开放注册")]), _vm._v(" "), _c('p', [_vm._v("4,新增时，若为新增某校下的校区，这时的是否开放注册会影响其他校区。")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "高校名称",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入高校名称",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.formedit.schoolname),
      callback: function($$v) {
        _vm.$set(_vm.formedit, "schoolname", $$v)
      },
      expression: "formedit.schoolname"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "校区名称",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入校区名称",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.formedit.campusname),
      callback: function($$v) {
        _vm.$set(_vm.formedit, "campusname", $$v)
      },
      expression: "formedit.campusname"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "省份",
      "label-width": _vm.formLabelWidth,
      "required": ""
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择省份",
      "clearable": "",
      "filterable": ""
    },
    on: {
      "change": function($event) {
        _vm.formedit.city = ''
      }
    },
    model: {
      value: (_vm.formedit.province),
      callback: function($$v) {
        _vm.$set(_vm.formedit, "province", $$v)
      },
      expression: "formedit.province"
    }
  }, _vm._l((_vm.provinceList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "市",
      "label-width": _vm.formLabelWidth,
      "required": ""
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择市",
      "clearable": "",
      "filterable": "",
      "disabled": !_vm.formedit.province
    },
    model: {
      value: (_vm.formedit.city),
      callback: function($$v) {
        _vm.$set(_vm.formedit, "city", $$v)
      },
      expression: "formedit.city"
    }
  }, _vm._l((_vm.cityOptionsEdit), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "首字母",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入首字母",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.formedit.firstletter),
      callback: function($$v) {
        _vm.$set(_vm.formedit, "firstletter", $$v)
      },
      expression: "formedit.firstletter"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开放注册",
      "label-width": "80px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.formedit.radio),
      callback: function($$v) {
        _vm.$set(_vm.formedit, "radio", $$v)
      },
      expression: "formedit.radio"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "2"
    },
    model: {
      value: (_vm.formedit.radio),
      callback: function($$v) {
        _vm.$set(_vm.formedit, "radio", $$v)
      },
      expression: "formedit.radio"
    }
  }, [_vm._v("否")])], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "校区切换权限",
      "label-width": "140px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "8px"
    }
  }, [_vm._v("允许切入")]), _vm._v(" "), _c('el-switch', {
    attrs: {
      "disabled": _vm.isDisabled,
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.formedit.openChangeCampusZone),
      callback: function($$v) {
        _vm.$set(_vm.formedit, "openChangeCampusZone", $$v)
      },
      expression: "formedit.openChangeCampusZone"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "8px"
    }
  }, [_vm._v("允许切出")]), _vm._v(" "), _c('el-switch', {
    attrs: {
      "disabled": _vm.isDisabled,
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.formedit.editChangeCampusZone),
      callback: function($$v) {
        _vm.$set(_vm.formedit, "editChangeCampusZone", $$v)
      },
      expression: "formedit.editChangeCampusZone"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "校区类型",
      "label-width": "80px"
    }
  }, [_c('el-row', [_c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formedit.schoolType == 1),
      expression: "formedit.schoolType == 1"
    }],
    attrs: {
      "span": 2
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    on: {
      "input": _vm.changeCampusType
    },
    model: {
      value: (_vm.formedit.campusType),
      callback: function($$v) {
        _vm.$set(_vm.formedit, "campusType", $$v)
      },
      expression: "formedit.campusType"
    }
  }, [_vm._v("专科")])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formedit.schoolType == 1),
      expression: "formedit.schoolType == 1"
    }],
    attrs: {
      "span": 1
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "2"
    },
    on: {
      "input": _vm.changeCampusType
    },
    model: {
      value: (_vm.formedit.campusType),
      callback: function($$v) {
        _vm.$set(_vm.formedit, "campusType", $$v)
      },
      expression: "formedit.campusType"
    }
  }, [_vm._v("本科")])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formedit.schoolType == 4),
      expression: "formedit.schoolType == 4"
    }],
    attrs: {
      "span": 2
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "3"
    },
    on: {
      "input": _vm.changeCampusType
    },
    model: {
      value: (_vm.formedit.campusType),
      callback: function($$v) {
        _vm.$set(_vm.formedit, "campusType", $$v)
      },
      expression: "formedit.campusType"
    }
  }, [_vm._v("高中")])], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formedit.schoolType == 1),
      expression: "formedit.schoolType == 1"
    }],
    attrs: {
      "label": "是否开启体测总分",
      "label-width": "140px"
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": "",
      "disabled": _vm.isDisabled
    },
    model: {
      value: (_vm.formedit.openTotalScore),
      callback: function($$v) {
        _vm.$set(_vm.formedit, "openTotalScore", $$v)
      },
      expression: "formedit.openTotalScore"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formedit.openTotalScore),
      expression: "formedit.openTotalScore"
    }],
    attrs: {
      "label": "体测总分:",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('div', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("大一")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.formedit.physicalConfig[0].molecule),
      callback: function($$v) {
        _vm.$set(_vm.formedit.physicalConfig[0], "molecule", $$v)
      },
      expression: "formedit.physicalConfig[0].molecule"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('div', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("/")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.formedit.physicalConfig[0].denominator),
      callback: function($$v) {
        _vm.$set(_vm.formedit.physicalConfig[0], "denominator", $$v)
      },
      expression: "formedit.physicalConfig[0].denominator"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1,
      "offset": 1
    }
  }, [_c('div', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("大二")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.formedit.physicalConfig[1].molecule),
      callback: function($$v) {
        _vm.$set(_vm.formedit.physicalConfig[1], "molecule", $$v)
      },
      expression: "formedit.physicalConfig[1].molecule"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('div', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("/")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.formedit.physicalConfig[1].denominator),
      callback: function($$v) {
        _vm.$set(_vm.formedit.physicalConfig[1], "denominator", $$v)
      },
      expression: "formedit.physicalConfig[1].denominator"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1,
      "offset": 1
    }
  }, [_c('div', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("大三")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.formedit.physicalConfig[2].molecule),
      callback: function($$v) {
        _vm.$set(_vm.formedit.physicalConfig[2], "molecule", $$v)
      },
      expression: "formedit.physicalConfig[2].molecule"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('div', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("/")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.formedit.physicalConfig[2].denominator),
      callback: function($$v) {
        _vm.$set(_vm.formedit.physicalConfig[2], "denominator", $$v)
      },
      expression: "formedit.physicalConfig[2].denominator"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formedit.campusType === '2'),
      expression: "formedit.campusType === '2'"
    }],
    attrs: {
      "span": 1,
      "offset": 1
    }
  }, [_c('div', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("大四")])]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formedit.campusType === '2'),
      expression: "formedit.campusType === '2'"
    }],
    attrs: {
      "span": 1
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.formedit.physicalConfig[3].molecule),
      callback: function($$v) {
        _vm.$set(_vm.formedit.physicalConfig[3], "molecule", $$v)
      },
      expression: "formedit.physicalConfig[3].molecule"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formedit.campusType === '2'),
      expression: "formedit.campusType === '2'"
    }],
    attrs: {
      "span": 1
    }
  }, [_c('div', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("/")])]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formedit.campusType === '2'),
      expression: "formedit.campusType === '2'"
    }],
    attrs: {
      "span": 1
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.formedit.physicalConfig[3].denominator),
      callback: function($$v) {
        _vm.$set(_vm.formedit.physicalConfig[3], "denominator", $$v)
      },
      expression: "formedit.physicalConfig[3].denominator"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "学校任务跑用户",
      "label-width": _vm.formLabelWidth,
      "required": ""
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.formedit.schoolTaskRunGrades),
      callback: function($$v) {
        _vm.$set(_vm.formedit, "schoolTaskRunGrades", $$v)
      },
      expression: "formedit.schoolTaskRunGrades"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("大一")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("大二")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": 3
    }
  }, [_vm._v("大三")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": 4
    }
  }, [_vm._v("大四")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": 5
    }
  }, [_vm._v("其他")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "运动世界APP固定展示“自由跑”",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.formedit.showFreeRunEnableSwitch),
      callback: function($$v) {
        _vm.$set(_vm.formedit, "showFreeRunEnableSwitch", $$v)
      },
      expression: "formedit.showFreeRunEnableSwitch"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormVisibleedit = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.editschoolsubmit
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5b81be27!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/xiaoyuan/GX/schoolManage.vue
// module id = 1037
// module chunks = 0